import MuiFormControl from '@material-ui/core/FormControl';
import styled from 'styled-components';

export const FormControl = styled(MuiFormControl)`
  padding: 0 16px;
  box-sizing: border-box;
`;
